// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LocationChoice from './logic'

export default function LocationChoiceFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LocationChoice">
      <LocationChoice {...props}>
        {children}
      </LocationChoice>
    </Flow>
  )
}
